import { render, staticRenderFns } from "./SurveyManagementLasWrapper.vue?vue&type=template&id=ff1545fa&scoped=true&"
import script from "./SurveyManagementLasWrapper.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementLasWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1545fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff1545fa')) {
      api.createRecord('ff1545fa', component.options)
    } else {
      api.reload('ff1545fa', component.options)
    }
    module.hot.accept("./SurveyManagementLasWrapper.vue?vue&type=template&id=ff1545fa&scoped=true&", function () {
      api.rerender('ff1545fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/questions/SurveyManagementLasWrapper.vue"
export default component.exports